import { observable, action } from "mobx";
import { makeApi, URLS } from "Utils/apiURL";

const defaultBulkStageUpdateObj = {
  contactCount: 0,
  contactIds: [],
  allContactsSelectedInView: false
};

class ContactBulkStageChangeState {
  @observable showBulkUpdateStagePopup = false;
  @observable bulkStageUpdateObj = { ...defaultBulkStageUpdateObj };

  @action
  setShowBulkUpdateStagePopup = (val = false) => {
    this.showBulkUpdateStagePopup = val;
  };

  @action
  setBulkStageUpdateObj = (obj = {}) => {
    this.bulkStageUpdateObj = obj;
  };

  @action
  resetBulkStageUpdateObj = () => {
    this.bulkStageUpdateObj = { ...defaultBulkStageUpdateObj };
  };

  @action
  bulkStageChange = async (
    contactStageId = "",
    contactIds = [],
    allContactsSelectedInView = false,
    totalCount = 0
  ) => {
    const config = {
      url: URLS.performContactsBulkOperation,
      method: "POST",
      data: {
        source: "CONTACT",
        type: "CONTACT_STAGE_UPDATE",
        totalCount,
        filter: {
          ...(allContactsSelectedInView ? {} : { contactIds })
        },
        data: {
          contactStageId
        }
      }
    };
    return await makeApi(config);
  };
}

const contactBulkStageChangeState = new ContactBulkStageChangeState();
export { contactBulkStageChangeState };
